import "./summaryTable.css";
import MultiSelectSearchCmp from "../../MultiSelectSearchCmp";
import { Tooltip } from "@mui/joy";
import UpArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/UpArrownIcon/elements.svg";
import DownArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/DownArrowIcon/elements.svg";
import ImageCmp from "../../ImageCmp";
import { useEffect, useRef, useState } from "react";

const SummaryTableEmpty = ({ 
  setSort,         // For saving state of sort
  sort,            // For Showing ASC & DESC Arrows 
  data,            // Summary Table Data 
  product_details_headerData,    // For Product Details Column Name in Header
  column,          // Metrics Column Name for accessing values from table data
  headerDateArr,    // For Metrics Column Name in Header
  period_type,     // For Formating Date, Week, Month, All in Header 
  categories, // For Showing all data in Filter DropDown in Table
  setCategories, // For sorting Categories Object arrays based on Search Input field
  sel_categories, // For showing Selected data in Filter DropDown in Table
  sel_categoriesdrawer,
  setSel_Categories, // For Updating data in Filter DropDown in Table
  onSelCategory,
  DropDownApplyBtn,
}) => {
    const [drill_through_enty_cols, setDrill_Through_entry_Cols] =  useState(["principal_category","main_category","category", "sub_category","product_name"])

    const productDetailRowRef = useRef(null);


  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatWeek = (weekStr) => { 
    const [yearno, monthno, week, weekno ] = weekStr?.split("-");

    const months = new Map([
      [1, "January"], [2, "February"], [3, "March"], [4, "April"],
      [5, "May"], [6, "June"], [7, "July"], [8, "August"],
      [9, "September"], [10, "October"], [11, "November"], [12, "December"]
  ]);

    return `W${weekno?.slice(1)}, ${months.get(Number(monthno))?.slice(0,3) }'${yearno?.slice(2)}`;
  }

  const formatMonth = (monthStr) => {
    const [yearno, monthno ] = monthStr?.split("-");

    const months = new Map([ 
      [1, "January"], [2, "February"], [3, "March"], [4, "April"],
      [5, "May"], [6, "June"], [7, "July"], [8, "August"],
      [9, "September"], [10, "October"], [11, "November"], [12, "December"]
  ]);
    return `${months.get(Number(monthno))?.slice(0,3)} ${yearno}`;
  }

  const calculateLeftPosition = (columnType) => {
    let left = 0;

    // Iterate over keys up to the current column to sum widths
    for (const column of product_details_headerData) {
      if (column.type === columnType) break; // Stop when reaching the current column
      left += column.width;
    }

    return left;
  };

  useEffect(() => {
          if (productDetailRowRef.current) {
            productDetailRowRef.current.scrollLeft = productDetailRowRef.current.scrollWidth;
          }
  }, [product_details_headerData]);

  const onSortHandler = (ipdate, ipmatrice_name) => {
    setSort((prev) => {
      if (prev.matrice_name !== ipmatrice_name || prev.sortbydate !==  ipdate) {
        return {
          matrice_name: ipmatrice_name,
          sortby: "ASC",
          sortbydate: ipdate
        };
      }
      else if (prev.matrice_name === ipmatrice_name && prev?.sortbydate === ipdate) {
        if (prev.sortby === "ASC") {
          return {
            ...prev,
            sortby: "DESC",
          };
        } else if (prev.sortby === "DESC") {
          return {
            ...prev,
            sortby: "",
          };
        } else if (prev.sortby === "") {
          return {
            ...prev,
            sortby: "ASC",
          };
        }
      }
    })
  }

  const getProduct_Details_Section_width = () => {
    let new_width = 0;

    product_details_headerData?.map((item) => {
        new_width += item?.width
    })
    return new_width;
  } 
  return (
    <div className="" style={{
        width: "calc(100vw - 71px - 40px)",
        height: "calc(100vh - 390px)",
        position: "relative"
      }}>
        <div className=" flex"
        style={{
            width: "calc(100vw - 71px - 40px)",
            height: "calc(100vh - 390px)",
        }}
        >
            {/* Left Side */}
            <div className=" flex flex-col" 
            ref={productDetailRowRef}
            style={{
              borderRight: "1px solid #EAEAED",
              borderLeft: "1px solid #EAEAED",
              overflow:"auto",
              position: "relative",
              boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
              maxHeight: "calc(100vh - 390px)",
              maxWidth: 350,
            }}>
                <div className="h-[87px] relative" style={{
                    // maxWidth:600,
                    width: getProduct_Details_Section_width()
                }}>
                    <div
                    className="flex h-[44px] px-22 py-2 justify-center items-center gap-2 self-stretch"
                    style={{
                      textAlign: "center",
                      background: "#F3F3F7",
                      borderBottom: "1px solid #EAEAED",
                      position:"sticky",
                      top:0,
                      left:0,
                      maxWidth: 350,
                    }}
                >
                    <div
                    style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "14px",
                    }}
                    >
                    Product Details
                    </div>
                </div>
                <div style={{ display: "flex", width: "100%"}}>
                    {product_details_headerData &&
                    product_details_headerData?.length > 0 &&
                    product_details_headerData?.map((d, index) => {

                        return (
                        <div
                        className="cell flex h-[44px] px-2 py-2 justify-between items-center gap-1"
                        style={{
                            width: d?.width,
                            backgroundColor: "#F3F3F7",
                            borderRight: product_details_headerData?.length - 1 === index ? "0px" : "1px solid #EAEAED",
                            position: "relative",
                        }}
                        key={d?.title_name}
                        >
                        <div
                            style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            textAlign: "start",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "14px",
                            }}
                        >
                            {d?.title_name}
                        </div>
                        <MultiSelectSearchCmp
                            searchcat={d?.type}
                            childrenarr={categories[d?.type]}
                            setCategories={setCategories}
                            selectedarr={sel_categoriesdrawer[d?.type]}
                            sel_categories={sel_categories}
                            setSel_Categories={setSel_Categories}
                            onSelCategory={onSelCategory}
                            DropDownApplyBtn={DropDownApplyBtn}
                        />
                        </div>
                    )})}
                </div>
                </div>

            </div>

            {/* Right Side */}
            <div 
            className="flex flex-col"
            style={{
                maxWidth:`calc(100vw - 71px - 40px - ${product_details_headerData?.length < 3 ? getProduct_Details_Section_width() : 350}px)`,
                overflow:"auto",
                position:"relative",
                maxHeight: "calc(100vh - 390px)",
                borderRight: "1px solid #EAEAED",
            }}>
                <div className="flex h-[87px]">
                    {headerDateArr.length > 0 &&
                    headerDateArr?.map((data,index1) => {
                        return (
                        <div className="flex flex-col">
                            <div
                            className="cell flex h-[44px] px-6 py-2 justify-center items-center gap-2 self-stretch"
                            style={{
                                textAlign: "center",
                                background: "#F3F3F7",
                            }}
                            >
                            <div
                                style={{
                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                textAlign: "center",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "14px",
                                }}
                            >
                                {period_type === "DAILY" ? formatDate(data?.date) : period_type === "WEEKLY" ? formatWeek(data?.date) : period_type === "MONTHLY" ? formatMonth(data?.date) : period_type === "ALL" && "ALL"}
                            </div>
                            </div>

                            <div className="flex ">
                            <div style={{ display: "flex" }}>
                                {data?.matrices_arr?.map((matrice, index2) => {
                            
                                return (
                                    <div
                                    key={matrice?.matrice_backend_name}
                                    className="cell flex h-[44px] px-1 py-2 justify-end items-center gap-1"
                                    style={{
                                        width: 80,
                                        backgroundColor: "#F3F3F7",
                                        borderRight: index2 === data?.matrices_arr?.length - 1 ? "1px solid #EAEAED" :"0px",
                                        cursor:"pointer"
                                    }}
                                    onClick={() => onSortHandler(data.date, matrice?.matrice_backend_name)}
                                    >
                                    <div
                                        style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "end",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "14px",
                                        }}
                                    >
                                        {matrice?.matrice_name}
                                    </div>
                                    {sort.sortbydate === data?.date && sort.matrice_name === matrice?.matrice_backend_name &&
                                        sort.sortby === "ASC" && (
                                        <img
                                            src={UpArrowIcon}
                                            alt="Icon"
                                            style={{ cursor: "pointer" }}
                                        />
                                        )}
                                    {sort.sortbydate === data?.date && sort.matrice_name === matrice?.matrice_backend_name &&
                                        sort.sortby === "DESC" && (
                                        <img
                                            src={DownArrowIcon}
                                            alt="Icon"
                                            style={{ cursor: "pointer" }}
                                        />
                                        )}
                                    </div>
                                );
                                })}
                            </div>
                            </div>
                        </div>
                        );
                    })}
                </div>

            </div>
        </div>

        <div
      className=" flex flex-col gap-10 justify-center items-center"
      style={{
        height: "calc(100vh - 72px - 410px)",
        width: "100%",
        position:"absolute",
        top:"87px",
        left: 0,
        backgroundColor:"#FFF"
      }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="192"
          height="162"
          viewBox="0 0 192 162"
          fill="none"
        >
          <g opacity="0.48">
            <g filter="url(#filter0_di_1399_54050)">
              <path
                d="M7.99902 46.0938H167.999V118.475C167.999 128.994 159.471 137.522 148.951 137.522H27.0466C16.5269 137.522 7.99902 128.994 7.99902 118.475V46.0938Z"
                fill="#DFE3E8"
              />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.7602 21.332C29.5598 21.332 27.0459 23.8459 27.0459 27.0463C27.0459 30.2459 29.5598 32.7606 32.7602 32.7606C35.9605 32.7606 38.4744 30.2459 38.4744 27.0463C38.4744 23.8459 35.9605 21.332 32.7602 21.332Z"
              fill="#C4CDD5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M50.8554 21.332C47.655 21.332 45.1411 23.8459 45.1411 27.0463C45.1411 30.2459 47.655 32.7606 50.8554 32.7606C54.0557 32.7606 56.5696 30.2459 56.5696 27.0463C56.5696 23.8459 54.0557 21.332 50.8554 21.332Z"
              fill="#C4CDD5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.9505 21.332C65.7502 21.332 63.2363 23.8459 63.2363 27.0463C63.2363 30.2459 65.7502 32.7606 68.9505 32.7606C72.1509 32.7606 74.6648 30.2459 74.6648 27.0463C74.6648 23.8459 72.1509 21.332 68.9505 21.332Z"
              fill="#C4CDD5"
            />
            <g filter="url(#filter1_di_1399_54050)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M167.999 23.2384V46.0951H7.99902L7.99902 23.2398C7.99902 14.8234 14.8219 8 23.2383 8H152.761C161.176 8 167.999 14.8227 167.999 23.2384ZM32.7609 21.3333C29.5605 21.3333 27.0466 23.8472 27.0466 27.0476C27.0466 30.2472 29.5605 32.7618 32.7609 32.7618C35.9612 32.7618 38.4751 30.2472 38.4751 27.0476C38.4751 23.8472 35.9612 21.3333 32.7609 21.3333ZM50.8561 21.3333C47.6557 21.3333 45.1418 23.8472 45.1418 27.0476C45.1418 30.2472 47.6557 32.7618 50.8561 32.7618C54.0564 32.7618 56.5703 30.2472 56.5703 27.0476C56.5703 23.8472 54.0564 21.3333 50.8561 21.3333ZM63.237 27.0476C63.237 23.8472 65.7509 21.3333 68.9512 21.3333C72.1516 21.3333 74.6655 23.8472 74.6655 27.0476C74.6655 30.2472 72.1516 32.7618 68.9512 32.7618C65.7509 32.7618 63.237 30.2472 63.237 27.0476Z"
                fill="#919EAB"
              />
            </g>
            <path
              opacity="0.48"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M143.813 58.1484H97.3015C94.7307 58.1484 92.6504 60.2253 92.6504 62.7919V118.514C92.6504 121.081 94.7307 123.157 97.3015 123.157H143.813C146.384 123.157 148.464 121.081 148.464 118.514V62.7919C148.464 60.2253 146.384 58.1484 143.813 58.1484Z"
              fill="#637381"
            />
            <path
              opacity="0.24"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.1853 67.4355H50.7899C53.3608 67.4355 55.4411 65.3586 55.4411 62.7919C55.4411 60.2253 53.3608 58.1484 50.7899 58.1484H32.1853C29.6145 58.1484 27.5342 60.2253 27.5342 62.7919C27.5342 65.3586 29.6145 67.4355 32.1853 67.4355ZM27.5342 81.366C27.5342 78.7993 29.6145 76.7225 32.1853 76.7225H78.6968C81.2677 76.7225 83.348 78.7993 83.348 81.366C83.348 83.9326 81.2677 86.0095 78.6968 86.0095H32.1853C29.6145 86.0095 27.5342 83.9326 27.5342 81.366ZM32.1853 95.2965C29.6145 95.2965 27.5342 97.3734 27.5342 99.94C27.5342 102.507 29.6145 104.583 32.1853 104.583H78.6968C81.2677 104.583 83.348 102.507 83.348 99.94C83.348 97.3734 81.2677 95.2965 78.6968 95.2965H32.1853ZM27.5342 118.514C27.5342 115.947 29.6145 113.87 32.1853 113.87H78.6968C81.2677 113.87 83.348 115.947 83.348 118.514C83.348 121.081 81.2677 123.157 78.6968 123.157H32.1853C29.6145 123.157 27.5342 121.081 27.5342 118.514Z"
              fill="#637381"
            />
          </g>
          <defs>
            <filter
              id="filter0_di_1399_54050"
              x="-0.000976562"
              y="38.0938"
              width="192"
              height="123.429"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="8" dy="8" />
              <feGaussianBlur stdDeviation="8" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1399_54050"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1399_54050"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-2" dy="-2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_1399_54050"
              />
            </filter>
            <filter
              id="filter1_di_1399_54050"
              x="-0.000976562"
              y="0"
              width="192"
              height="70.0947"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="8" dy="8" />
              <feGaussianBlur stdDeviation="8" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1399_54050"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1399_54050"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_1399_54050"
              />
            </filter>
          </defs>
        </svg>
        <div
          style={{
            color: "var(--Text-Primary-Grey, #97979A)",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          No Result Found. Please Choose Another Filter.
        </div>
      </div>
    </div>
    
  );
};

export default SummaryTableEmpty;
